import React from 'react'
import { ChevronLeft, Menu } from 'lucide-react'
import { useLocation } from 'react-router-dom'

import { useTranslation } from '@/features/locale/LocaleProvider'

import { useMobileBrowseTitleContext } from './MobileBrowseTitleContext'
import { useMobileNavigateBack } from './useMobileNavigateBack'

interface MobileAppHeaderProps {
  onMenuClick: () => void
}

/** Cabecera browse móvil: volver (izq) + título + menú (der). Sin back en Home. */
export function MobileAppHeader({ onMenuClick }: MobileAppHeaderProps) {
  const t = useTranslation()
  const { pathname } = useLocation()
  const { title } = useMobileBrowseTitleContext()
  const navigateBack = useMobileNavigateBack()
  const showBack = pathname !== '/'

  return (
    <header className="mobile-app__header-bar md:hidden">
      {showBack ? (
        <button type="button" className="mobile-app__menu-btn" onClick={navigateBack} aria-label={t.common.back}>
          <ChevronLeft className="size-5" />
        </button>
      ) : (
        <span className="mobile-app__header-spacer" aria-hidden />
      )}
      <h1 className="mobile-app__header-title">{title}</h1>
      <button type="button" className="mobile-app__menu-btn" onClick={onMenuClick} aria-label={t.common.openMenu}>
        <Menu className="size-5" />
      </button>
    </header>
  )
}
